export default __webpack_public_path__ + "img/homepage-desktop-zumper-rentals.e80b6972.svg";